import {Component} from "react";
import myEmitter from "./my-events";
import demo from "../imgs/demo.jpg";
import {Radio} from "antd";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as setAnswer from "../actions/evaluation";
import React from "react";
import {requestPost} from "../utils/Util";
const RadioGroup = Radio.Group;
class Match extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        }
    }


    _handlerNextQuestion = (action)=>{

    }


    _doSetAnswer(action) {

    }

    componentWillUnmount() {
        myEmitter.off('nextQuestion', this._handlerNextQuestion);
        myEmitter.off('prevQuestion', this._handlerNextQuestion);
    }

    componentDidMount() {
        myEmitter.on('prevQuestion', this._handlerNextQuestion);
        myEmitter.on('nextQuestion', this._handlerNextQuestion);
    }


    onChange = (e) => {
        console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        });
    }

    render() {
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
        };
        const {answer,evaluation,currentEvaluation} = this.props;
        var correctAnswers = "";
        var h = evaluation.datas.length > 0 ? Object.values(Object.values(evaluation.datas[currentEvaluation.page])[0])[0] : '';

        return (
            <div className='questionItem'>

                <div className='options'>
                    <p>题号：{h?h.number:""}</p>
                    <p  dangerouslySetInnerHTML={{__html: !h ? '' : h.description}} />
                    <div className='options_group'>
                        <RadioGroup value={this.state.value}>
                            {
                                h.options.map((item,index)=>{
                                    if(item.answer){
                                        correctAnswers += item.letter;
                                    }
                                    return <Radio style={radioStyle} value={item.id} checked={item.answer}><span style={{marginRight:10}}>{item.letter} </span>
                                        <span dangerouslySetInnerHTML={{__html: item.value}}/></Radio>
                                })
                            }

                        </RadioGroup>
                    </div>
                    <div className='analysisTitle' >解析：正确答案为 {correctAnswers}</div>
                    <div className='analysis'>
                        <p className='content' dangerouslySetInnerHTML={{__html: h.explanation}}/>
                    </div>
                </div>
            </div>
        );
    }
}

Match = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))(Match);

export {Match};